import * as React from 'react';
import Flex from './Flex';
import {Divider, Typography} from 'antd';
const {Text, Title} = Typography;

export default function CustomerError(props: {title?: string; statusCode?: number}) {
  return (
    <Flex direction={'column'} align={'center'} justify={'center'} style={{height: 300}}>
      {/*<img src="/images/error-server.png" alt="error" style={{width: 200, marginBottom: 10}} />*/}
      <Title level={2}>{props.title}</Title>
      <Flex align={'center'}>
        <a onClick={() => history.go(-1)} className={'mh-md'}>
          返回上一页
        </a>
        <Divider style={{backgroundColor: '#777'}} type={'vertical'} />
        <a href="/" className={'mh-md'}>
          回到首页
        </a>
        <Divider style={{backgroundColor: '#777'}} type={'vertical'} />
        <a href="/user/login" className={'mh-md'}>
          前往登录页面
        </a>
      </Flex>
    </Flex>
  );
}
